export const APP_TITLE = '仟信在线客服';
/** 当前运行环境，见 config/api.config.js */
export const APP_ENV = __APP_ENV__;
export const APP_ENV_LABEL = __APP_ENV_LABEL__;
/** 后端接口前缀，构建时由 webpack 从 config/api.config.js 注入 */
export const API_BASE = __API_BASE__;
/**
 * 微信内相对路径偶发解析异常，统一成绝对地址。
 * 已是 http(s) 则原样返回。
 */
export function resolveApiUrl(path = '') {
    const base = API_BASE || '';
    const suffix = path || '';
    if (/^https?:\/\//i.test(base)) {
        return `${base.replace(/\/$/, '')}${suffix.startsWith('/') ? suffix : suffix ? `/${suffix}` : ''}`;
    }
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const normalizedBase = base.startsWith('/') ? base : `/${base}`;
    return `${origin}${normalizedBase.replace(/\/$/, '')}${suffix.startsWith('/') ? suffix : suffix ? `/${suffix}` : ''}`;
}
export const ACCESS_ID = {
    APP: 'app-default',
    WECHAT: 'wechat-mp',
};
